<script setup lang="ts">
import BAdminInput from 'src/shared/components/base/BAdminInput/BAdminInput.vue';
import useValidators from 'src/shared/composables/useValidators';
import { useI18n } from 'vue-i18n';
import type { ChangePasswordData } from '../../types';

const { t } = useI18n();
const model = defineModel<ChangePasswordData>('changePasswordData', {
  default: (): ChangePasswordData => ({
    currentPassword: '',
    password: '',
    passwordConfirmation: '',
  }),
});

const emits = defineEmits<{
  changePassword: [];
  forgotPassword: [];
}>();

const { required, min } = useValidators();
</script>

<template>
  <q-form
    autocomplete="off"
    @submit.prevent="emits('changePassword')"
  >
    <BAdminInput
      v-model="model.currentPassword"
      type="password"
      :label="t('CURRENT_PASSWORD')"
      :rules="[required]"
      outlined
      class="q-mb-md"
      autocomplete="current-password"
      dark
    />

    <BAdminInput
      v-model="model.password"
      type="password"
      :label="t('NEW_PASSWORD')"
      :rules="[required, (val: string) => min(val, 6)]"
      outlined
      class="q-mb-md"
      autocomplete="new-password"
      dark
    />

    <BAdminInput
      v-model="model.passwordConfirmation"
      type="password"
      :label="t('CONFIRM_NEW_PASSWORD')"
      :rules="[
        required,
        (val: string) => val === model.password || t('PASSWORDS_MUST_MATCH'),
      ]"
      outlined
      class="q-mb-md"
      autocomplete="new-password"
      dark
    />

    <q-separator />

    <div class="row form-actions q-gutter-md q-py-md justify-between">
      <q-btn
        outline
        :label="t('CHANGE_PASSWORD')"
        type="submit"
      />
    </div>
  </q-form>
</template>
